import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  AnalyticsLogMoviePlayParams,
  AnalyticsLogMoviePlaySecondsParams,
  AnalyticsLogMovieSearchParams,
  AnalyticsLogTagMovieParams,
} from 'src/models/apis/analytics/analyticsRequest';

export default {
  logMoviePlay(params: AnalyticsLogMoviePlayParams): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/movie/play'), params);
  },
  logMoviePlaySeconds(params: AnalyticsLogMoviePlaySecondsParams): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/movie/play_seconds'), params);
  },
  logMovieSearch(params: AnalyticsLogMovieSearchParams): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/movie/search'), params);
  },
  logTagMovieAdd(params: AnalyticsLogTagMovieParams): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/tag_movie/add'), params);
  },
  logTagMovieDelete(params: AnalyticsLogTagMovieParams): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/tag_movie/delete'), params);
  },
  logCommentAdd(): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/comment/add'));
  },
  logCommentDelete(): Promise<AxiosResponse<Record<string, []>>> {
    return api.post(utils.getApiUrl('/analytics/comment/delete'));
  },
};
